import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarActions, MatSnackBarRef} from '@angular/material/snack-bar';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-snack-bar',
  imports: [
    MatSnackBarActions,
    TranslatePipe,
    MatIcon,
    MatIconButton
  ],
  templateUrl: './snack-bar.component.html',
  styleUrl: './snack-bar.component.scss'
})
export class SnackBarComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
              protected snackBarRef: MatSnackBarRef<SnackBarComponent>) {
  }
}
